var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

var FormGroup = function FormGroup(_ref) {
  var legendText = _ref.legendText,
      invalid = _ref.invalid,
      children = _ref.children,
      className = _ref.className,
      message = _ref.message,
      messageText = _ref.messageText,
      other = _objectWithoutProperties(_ref, ['legendText', 'invalid', 'children', 'className', 'message', 'messageText']);

  var classNamesLegend = classnames('bx--label', className);
  var classNamesFieldset = classnames('bx--fieldset', className);

  return React.createElement(
    'fieldset',
    _extends({}, invalid && { 'data-invalid': '' }, {
      className: classNamesFieldset
    }, other),
    React.createElement(
      'legend',
      { className: classNamesLegend },
      legendText
    ),
    children,
    message ? React.createElement(
      'div',
      { className: 'bx--form__requirements' },
      messageText
    ) : null
  );
};

FormGroup.propTypes = {
  children: PropTypes.node,
  legendText: PropTypes.string,
  className: PropTypes.string,
  invalid: PropTypes.bool,
  message: PropTypes.bool,
  messageText: PropTypes.string
};

FormGroup.defaultProps = {
  invalid: false,
  message: false,
  messageText: 'Provide message text',
  legendText: 'Provide legend text'
};

export default FormGroup;


//////////////////
// WEBPACK FOOTER
// ./node_modules/carbon-components-react/es/components/FormGroup/FormGroup.js
// module id = 328
// module chunks = 0